'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ravenJs = require('raven-js');

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _reactResponsiveModal = require('react-responsive-modal');

var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    _classCallCheck(this, ErrorBoundary);

    return _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).apply(this, arguments));
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, errorInfo) {
      this.props.onError(error, { componentError: errorInfo });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.hasError) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactResponsiveModal2.default,
            {
              open: true,
              little: true,
              closeOnOverlayClick: false,
              showCloseIcon: false,
              onClose: function onClose() {
                return null;
              },
              classNames: { overlay: 'loading-overlay', modal: 'modal-wrapper error-form' }
            },
            _react2.default.createElement(
              'div',
              { className: 'error-report-form' },
              _react2.default.createElement(
                'h2',
                null,
                'We\'re sorry \u2013 something has gone wrong.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Our team has been notified.',
                _react2.default.createElement('br', null),
                'If you\'d like to provide us with more information:'
              ),
              _react2.default.createElement(
                'div',
                { className: 'actions' },
                _react2.default.createElement(
                  'button',
                  {
                    name: 'report',
                    className: 'btn back',
                    onClick: function onClick() {
                      if (_ravenJs2.default.lastEventId()) {
                        _ravenJs2.default.showReportDialog();
                      }
                    }
                  },
                  'Fill Out a Report'
                ),
                _react2.default.createElement(
                  'button',
                  { className: 'btn', name: 'reload', onClick: function onClick() {
                      return window.location.reload();
                    } },
                  'Reload ',
                  this.props.appName
                )
              )
            )
          )
        );
      }
      return this.props.children;
    }
  }]);

  return ErrorBoundary;
}(_react2.default.Component);

ErrorBoundary.defaultProps = {
  hasError: false,
  appName: 'App'
};

ErrorBoundary.propTypes = {
  children: _propTypes2.default.node.isRequired,
  onError: _propTypes2.default.func.isRequired,
  hasError: _propTypes2.default.bool,
  appName: _propTypes2.default.string
};

exports.default = ErrorBoundary;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/ErrorBoundary.js
// module id = 1000
// module chunks = 0